import { z } from 'zod';

/** Wire code of the demo gate's refusal body. The web client imports this to stay silent on a refusal. */
export const DEMO_GATE_DENIED_CODE = 'demo_unavailable' as const;

// Same body for every refusal, so a response never says which route or which check refused it.
export const DemoGateDeniedSchema = z.object({
  type: z.literal('about:blank'),
  title: z.literal('Not Found'),
  status: z.literal(404),
  code: z.literal(DEMO_GATE_DENIED_CODE),
});

export const DEMO_GATE_DENIED_BODY: z.infer<typeof DemoGateDeniedSchema> = Object.freeze({
  type: 'about:blank',
  title: 'Not Found',
  status: 404,
  code: DEMO_GATE_DENIED_CODE,
});
